import { render, staticRenderFns } from "./ServicePayments.vue?vue&type=template&id=4a5a61a5"
import script from "./ServicePayments.vue?vue&type=script&lang=js"
export * from "./ServicePayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports